import { connect } from 'react-redux'
import { ModalComponent } from '../component'

export const Modal = connect(({ backOffice }) => ({
  modal: backOffice.modalObj,
}))(ModalComponent)
